import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';

export const Form = ({ onSubmit, isReset, children, defaultValues, id, mode = 'onSubmit' }) => {
  const context = useForm({ defaultValues, mode });

  useEffect(() => {
    if (isReset) {
      context.reset();
    }
  }, [isReset]);

  return (
    <FormProvider { ...context }>
      <form onSubmit={context.handleSubmit(onSubmit)} data-test-id="millesima-form" id={id}>
        {children}
      </form>
    </FormProvider>
  );
};

Form.propTypes = {
  onSubmit: PropTypes.func,
  children: PropTypes.any,
  isReset: PropTypes.bool,
  defaultValues: PropTypes.object,
  id: PropTypes.string
};

export default Form;
